import { render, staticRenderFns } from "./PreviewLayer.vue?vue&type=template&id=fa3165f2&scoped=true"
import script from "./PreviewLayer.vue?vue&type=script&lang=js"
export * from "./PreviewLayer.vue?vue&type=script&lang=js"
import style0 from "./PreviewLayer.vue?vue&type=style&index=0&id=fa3165f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3165f2",
  null
  
)

export default component.exports